<div class="mask" *ngIf="isLoading">
    <div class="spinner-wrap">
        <div class="spinner">
            <mat-spinner
                    [diameter]="diameter"
                    [strokeWidth]="strokeWidth"></mat-spinner>
        </div>
        <span>{{loadingTip||'Loading...'}}</span>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/page.spinner/page.spinner.component.html